import { fg } from '@confluence/feature-gating';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import {
	CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT,
	CREATION_FOCUSED_NAV_START_TIME,
	NAV_EXPERIMENT_ONBOARDING_KEYS,
} from '../../constants/onboarding-state/onboarding-constants.ts';

import onboardingStateGetOnboardingStateQuery, {
	type onboardingStateGetOnboardingStateQuery$data,
	type onboardingStateGetOnboardingStateQuery$variables,
} from './__generated__/onboardingStateGetOnboardingStateQuery.graphql.ts';

type Result = { data: unknown; hasErrors: boolean };

export const preloadSideNavigationOnboardingState = (
	onResult?: (result: Result) => void | Promise<void>,
): Promise<Result> => {
	const promise = query<
		onboardingStateGetOnboardingStateQuery$data,
		onboardingStateGetOnboardingStateQuery$variables
	>({
		query: onboardingStateGetOnboardingStateQuery,
		variables: {
			key: fg('cc_activation_simplify_nav_preloader_enabled')
				? [...NAV_EXPERIMENT_ONBOARDING_KEYS]
				: [CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT, CREATION_FOCUSED_NAV_START_TIME],
		},
	});
	if (onResult) {
		return promise.then(async (result) => {
			await onResult(result);
			return result;
		});
	}
	return promise;
};
